import React, { useEffect, useState } from 'react'
import Input from '../../inputs/Input';
import BtnSubmit from '../../buttons/BtnSubmit';
import axios from 'axios';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

export default function StartForm() {
   const [name, setName] = useState();
   const [code, setCode] = useState();

   let flag = 0;
   const location = useLocation();
   const [type, setType] = useState(new URLSearchParams(location.search).get('type'));
   const [id,setId] = useState(new URLSearchParams(location.search).get('id')  );
   const [student,setStudent] = useState(new URLSearchParams(location.search).get('student') | 0 );
   const [telegramId,setTelegramId] = useState(new URLSearchParams(location.search).get('telegram-id') | 0 );
   const navigate = useNavigate();
   const handlerInput = (text) => {
      setName(text);
   }
   //entity-c2f3db8b320396c0
   useEffect(()=>{
    if(id === null){
      navigate("/error");
    }
    if(student != 0){
      handleSubmit();
    }  
   })
   const handleSubmit = async() => {
     console.log("hundeled subbmit");
     if(flag==0){
        try {
          flag = 1;
          axios.post('/appi/quiz/test/start',
              JSON.stringify({name,id,type,student,telegramId}), {
                  withCredentials: true,
                  headers: {
                      'Content-Type': 'application/json',
                  },
              }
          ).then(response=>{
            if(response.data.code){
              setCode(response.data.code);
              localStorage.setItem("test-quiz-progress",response.data.code);
              axios.get('/appi/quiz/test/'+ response.data.code + '/'+ type, { withCredentials: true })
              .then(response=>{
                localStorage.setItem("test-quiz",JSON.stringify(response.data));
                console.log(response.data);
                navigate('/test');
                
              })
              .catch(error => {
        
              });
            }
           
          }).catch(error => {

          })
        
        
      } catch(err) {
      }
     }
    
 }
  return (
    <div className='page'>  

        {student === 0 ? <div> <h1>Для початку напиши своє імя</h1>
        <Input className="s-inp" hint="Напиши ім'я.." onListenner={handlerInput} />
        <BtnSubmit name="Почати" onListenner={handleSubmit}/> </div> : ''}
      
      </div>  
    
      
  )
}
